import React, { useState, useEffect } from "react";

interface CustomDateCalendarProps {
    selectedDate: Date | null;
    onDateChange: (date: Date) => void;
    onClose: () => void;
}

const CustomDateCalendar: React.FC<CustomDateCalendarProps> = ({
    selectedDate,
    onDateChange,
    onClose,
}) => {
    const today = new Date();
    const initialDate = selectedDate || today;
    const [currentMonth, setCurrentMonth] = useState(initialDate.getMonth());
    const [currentYear, setCurrentYear] = useState(initialDate.getFullYear());

    const [selectedDay, setSelectedDay] = useState(initialDate.getDate());

    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];

    const daysInMonth = (month: number, year: number): number => {
        return new Date(year, month + 1, 0).getDate();
    };

    const isFutureDate = (day: number): boolean => {
        const date = new Date(currentYear, currentMonth, day);
        return date > today;
    };

    const handleDayClick = (day: number) => {
        if (!isFutureDate(day)) {
            setSelectedDay(day);
        }
    };

    const handleMonthChange = (offset: number) => {
        const newDate = new Date(currentYear, currentMonth + offset);
        setCurrentMonth(newDate.getMonth());
        setCurrentYear(newDate.getFullYear());
    };

    const handleConfirm = () => {
        const newDate = new Date(currentYear, currentMonth, selectedDay);
        if (newDate <= today) {
            onDateChange(newDate);
            onClose();
        }
    };

    return (
        <div className="custom-calendar-containers">
            <div className="calendar-header d-flex justify-content-between align-items-center">
                <button className="nav-btn" onClick={() => handleMonthChange(-1)}>&#8592;</button>
                <div className="selected-month-name display-6">
                    {months[currentMonth]} {currentYear}
                </div>
                <button
                    className="nav-btn"
                    onClick={() => handleMonthChange(1)}
                    disabled={
                        currentYear === today.getFullYear() &&
                        currentMonth >= today.getMonth()
                    }
                >
                    &#8594;
                </button>
            </div>

            <div className="day-grid mt-3">
                {[...Array(daysInMonth(currentMonth, currentYear))].map((_, index) => {
                    const day = index + 1;
                    const disabled = isFutureDate(day);
                    return (
                        <div
                            key={day}
                            className={`day-item ${day === selectedDay ? "selected-day" : ""} ${disabled ? "disabled" : ""}`}
                            onClick={() => !disabled && handleDayClick(day)}
                        >
                            {day}
                        </div>
                    );
                })}
            </div>

            <div className="calendar-footer mt-3">
                <button
                    className="cancel-btn"
                    onClick={() => {
                        onDateChange(new Date()); 
                        onClose();               
                    }}
                >
                    CANCEL
                </button>
                <button className="confirm-btn" onClick={handleConfirm}>
                    OK
                </button>
            </div>

        </div>
    );
};

export default CustomDateCalendar;
